import { V2PaymentResponse } from '@api';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs';
import { IAction } from 'src/js/actions/IshAction';
import { Reply, Request } from 'src/js/common/epics/EpicUtils';
import CheckoutServiceV2 from 'src/js/enrol/services/CheckoutApiService';
import { IshState } from 'src/js/services/IshState';
import CheckoutService from '../../../services/CheckoutService';
import { GET_PAYMENT_STATUS } from '../actions/Actions';

const request: Request<V2PaymentResponse, IshState> = {
  type: GET_PAYMENT_STATUS,
  getData: (payload: any, state: IshState): Promise<V2PaymentResponse> => {
    return CheckoutServiceV2.getStatus(state.checkout.payment.sessionId);
  },
  processData: (response: V2PaymentResponse): IAction<any>[] | Observable<any> => {
    return CheckoutService.processPaymentResponse(response);
  },
};

export const GetPaymentStatus: Epic<any, any> = Reply(request, 3);
